import { render } from "./ForgotPasswordSubmission.vue?vue&type=template&id=4c7f8aba&scoped=true"
import script from "./ForgotPasswordSubmission.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSubmission.vue?vue&type=script&lang=js"

import "./ForgotPasswordSubmission.vue?vue&type=style&index=0&id=4c7f8aba&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7f8aba"]])

export default __exports__